import { render, staticRenderFns } from "./Lay.vue?vue&type=template&id=4d191972&"
import script from "./Lay.vue?vue&type=script&lang=js&"
export * from "./Lay.vue?vue&type=script&lang=js&"
import style0 from "./Lay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports